import { extensions } from '../../extensions/Extensions';
import { GraphicsContextSystem } from './shared/GraphicsContextSystem';
import { GraphicsPipe } from './shared/GraphicsPipe';

extensions.add(GraphicsPipe);
extensions.add(GraphicsContextSystem);
